import React from "react";
import { entityDescriptors } from "@crispico/foundation-react/entity_crud/entityCrudConstants";
import { EntityDescriptor, Utils } from "@crispico/foundation-react";

export class AbstractInfoRendererProps {
    entity?: any
    /**
     * This prop allow null/undefined, but it should always exists, but for now in all places is set w/ the defaultProps.
     * E.g FlightInfoRenderer: static defaultProps = { entityName: "Flight" }
     */
    entityName?: string
    hideTitle?: boolean
}

export class AbstractInfoRenderer<P extends AbstractInfoRendererProps = AbstractInfoRendererProps> extends React.Component<P> {

    getEntityDescriptor(): EntityDescriptor {
        if (!this.props.entityName) {
            throw new Error("Entity name must exists!")
        }
        return entityDescriptors[this.props.entityName!];
    }

    renderTitle() {
        return <>{!this.props.hideTitle && <span className="small-margin-bottom">{this.getEntityDescriptor().getLabel()}</span>}</>;
    }

    renderContent() {
        return <></>;
    }

    render() {
        return !Utils.isNullOrEmpty(this.props.entity) ? <>
            {this.renderTitle()}
            {this.renderContent()}
        </> : null;
    }
}
